import { Component, OnInit, Input } from '@angular/core';
import { AngularFireDatabase, AngularFireObject } from 'angularfire2/database';
import { SoundService } from '../../services/sound.service';
import { Router } from '@angular/router';

@Component({
  selector: 'bot-summary',
  templateUrl: './bot-summary.component.html',
  styleUrls: ['./bot-summary.component.scss']
})
export class BotSummaryComponent implements OnInit {

  @Input('bot') botName: string; // bot name

  buyOrders = [];
  sellOrders = [];
  price = 0;
  priceChange = 0;
  resetPrice = 0;
  heartbeat;

  constructor(private db: AngularFireDatabase, private soundService: SoundService, private router: Router) { }

  ngOnInit() {
    this.initDatabase();
  }

  goToBot(bot) {
    this.router.navigate(['dashboard', bot]);
  }

  initDatabase() {
    // heartbeat
    this.db.object('bots/' + this.botName + '/heartbeat')
      .valueChanges().subscribe(value => {
        this.heartbeat = new Date(Number(value));
      });
    
    // price
    let priceRef = this.db.object('/bots/' + this.botName + '/price');
    priceRef.valueChanges().subscribe(price => {
      var newPrice = Number(price);
      if(this.price > 0) {
        this.priceChange = newPrice - this.price;
      }
      this.price = newPrice;
    });

    // reset
    let resetPriceRef = this.db.object('/bots/' + this.botName + '/resetPrice');
    resetPriceRef.valueChanges().subscribe(resetPrice => {
      this.resetPrice = Number(resetPrice);
    });

    // buy orders
    let buyOrdersRef = this.db.list('/bots/' + this.botName + '/buyOrders');
    buyOrdersRef.valueChanges().subscribe(data => {
      let sorted = data.sort(function (a: any, b: any) { return (a.fibNum > b.fibNum) ? 1 : -1; });
      this.buyOrders = sorted;
    });

    // sell orders
    let sellOrdersRef = this.db.list('/bots/' + this.botName + '/sellOrders');
    sellOrdersRef.valueChanges().subscribe(data => {
      let sorted = data.sort(function(a: any, b: any) { return (Number(a.price) > Number(b.price)) ? 1: -1;});
      this.sellOrders = sorted;
    });

    // sounds
    let firstSoundCheck = true;
    this.db.list('/bots/' + this.botName + '/logs',
      ref => ref.limitToLast(1)
    ).valueChanges().subscribe(logs => {
      if(firstSoundCheck) {
        firstSoundCheck = false;
        return;
      }
      this.soundService.checkLogForSound(logs[0]);
    });

  }
}



// WEBPACK FOOTER //
// C:/Users/mybrokenwalls/workspace/mybrokenwalls/portfolio/src/app/components/bot-summary/bot-summary.component.ts